import { render, staticRenderFns } from "./PopoverSelect.vue?vue&type=template&id=13c2b6b4&scoped=true&"
import script from "./PopoverSelect.vue?vue&type=script&lang=js&"
export * from "./PopoverSelect.vue?vue&type=script&lang=js&"
import style0 from "./PopoverSelect.vue?vue&type=style&index=0&id=13c2b6b4&prod&lang=scss&scoped=true&"
import style1 from "./PopoverSelect.vue?vue&type=style&index=1&id=13c2b6b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2b6b4",
  null
  
)

export default component.exports